import {Component, OnInit, Inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PortfolioService} from '../shared/profile/portfolio.service';

import {DOCUMENT} from '@angular/common';
import {PageScrollInstance, PageScrollService, PageScrollConfig} from 'ngx-page-scroll';
import {TrackingServiceService} from '../shared/service/tracking-service.service';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
    data: any;
    imgName = 1;

    constructor(private route: ActivatedRoute,
                private port: PortfolioService,
                private pageScrollService: PageScrollService,
                private track: TrackingServiceService,
                @Inject(DOCUMENT) private document) {
        PageScrollConfig.defaultScrollOffset = 70;
        PageScrollConfig.defaultDuration = 500;
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.data = this.port.getPortfolioByName(params['name']);
        });
    }

    viewImage(name) {
        this.imgName = name;
        this.track.eventTracking('click portfolio image', this.data.name, 'view image' + name);
        const pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#img_preview');
        this.pageScrollService.start(pageScrollInstance);
    }

    getImg(vector) {
        if (vector === 'next' && (this.imgName <= this.data.images.length - 1)) {
            this.imgName += 1;
        } else if (vector === 'previous' && (this.imgName > 1)) {
            this.imgName -= 1;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/gallery/gallery.component.ts